<template>
    <FormulateInput
      ref="time-duration"
      v-model="item[field.key]"
      v-bind="field"
      :initialValues="initialValues"
      :rowItem="item"
      :label="null"
      :name="field.key"
      :type="field.type || 'text'"
      :validation-name="field.label"
      :disabled="disabled"
      validation-behavior="live"
      error-behavior="value"
      size="sm"
      class="p-0"
      @input="$emit('input', $event)"
      @change-popup-state="handleChangePopupState"
    >
      <template #prefix>
        <div class="formulate-input-prefix">
          <span>+</span>
        </div>
      </template>
    </FormulateInput>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      default: () => {},
    },
    item: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false
    },
    initialValues: {
      type: String,
      default: null,
    },
    /** 
     * To position the time duration input result above other elements using a fixed
     * positioning, add the class 'fixed-input-wrapper' to the element you want the
     * time duration value to appear above.
     */ 
    fixed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  data() {
    return {
      inputPosition: null,
      popupRef: null,
      isOpen: false
    }
  },
  watch: {
    // check for the position of the popup is changed or not when scrolling
    inputPosition: {
      handler() {
        if (this.fixed) {
          this.updatePopupStyle()
        }
      },
      deep: true
    },
  },
  mounted() {
    if (this.fixed) {
      this.startPositionCheck()
    }
  },
  methods: {
    handleChangePopupState(popup) {
      this.isOpen = popup ? true : false

      if (popup) {
        this.popupRef = popup
        this.popupRef.style.position = "fixed"
        this.popupRef.style.zIndex = "100"
        if (this.fixed) {
          this.$nextTick(() => {
            this.updatePopupStyle()
          })
        }
      }
    },
    startPositionCheck() {
      const checkPosition = () => {
        if (this.$el) {
          const rect = this.$el.getBoundingClientRect()
          this.inputPosition = { top: rect.top, left: rect.left }
        }
        requestAnimationFrame(checkPosition)
      }
      checkPosition()
    },
    // update position of the popup time duration during the scrolling
    updatePopupStyle() {
      if (!this.isOpen || !this.popupRef || !this.inputPosition) return

      const detailSection = document.querySelector('.fixed-input-wrapper')
      if (!detailSection) return

      const popupRect = this.popupRef.getBoundingClientRect()
      const windowHeight = window.innerHeight

      let top = this.inputPosition.top + this.$el.offsetHeight
      if (top + popupRect.height > windowHeight) {
        top = this.inputPosition.top - popupRect.height
      }

      this.popupRef.style.top = `${top}px`
      this.popupRef.style.left = `${this.inputPosition.left}px`
    },
  }
}
</script>